module.exports = __webpack_public_path__ + "static/media/one_time_payment.cf5c2946.svg";